import { EnAgrupamentoProcessos, EnOrdemProcesso, IProcess } from '@medlogic/shared/shared-interfaces';

export const filterShowMobileAndModulesMenu = (processByUser: IProcess): boolean => {
    // return !processByUser?.blInativo &&
    //   (processByUser?.OrderNo === this.ORDERNO_TO_SHOW_MENU);
    return !processByUser?.blInativo &&
        [EnAgrupamentoProcessos.Individual, EnAgrupamentoProcessos.Todos].includes(processByUser?.AgrupamentoProcessosNo) &&
        [EnOrdemProcesso.SomenteSistemaEObedeceAgrupamento, EnOrdemProcesso.SistemaEAppEObedeceAgrupamento].includes(processByUser?.OrderNo);
}
